import React from "react";

export type AuthInfo = {
  provider: string;
  token?: string;
  sessionId?: string;
  config?: Record<string, unknown>;
} | null;

export type AuthenticationContextValue = {
  authInfo: AuthInfo;
  isAuthenticated: boolean;
  login: (_authInfo: AuthInfo, _redirect?: ((_params?: unknown) => void) | null, _params?: unknown) => Promise<void>;
  logout: () => void;
};

const AuthenticationContext = React.createContext<AuthenticationContextValue | undefined>(undefined);

if (process.env.NODE_ENV !== "production") {
  AuthenticationContext.displayName = "AuthenticationContext";
}

export default AuthenticationContext;
